import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-576fb8ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-modal" }
const _hoisted_2 = { class: "bg-white" }
const _hoisted_3 = { class: "position-relative py-4 px-3" }
const _hoisted_4 = { class: "fixed-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, null, {
        left: _withCtx(() => [
          _createVNode(_component_FeatherIcon, {
            icon: "chevron-left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickBack')))
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppButton, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save'))),
            variant: "success",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n            設定\n          ")
            ], undefined, true),
            _: 1
          })
        ])
      ])
    ])
  ]))
}